import React from 'react';
import EmployeeListView from './EmployeeListView';
import Query from '../../../../graphql/Query';
import { EmployeeListProps } from './types';
import { GET_EMPLOYEES } from '../../graphql';

const EmployeeList = () => {
    return (
        <Query<EmployeeListProps> query={GET_EMPLOYEES}>
            {({ data: { employees } }) => <EmployeeListView employees={employees} />}
        </Query>
    );
};

export default EmployeeList;
